<script>
import Transactions from "./transactions";
import Pagination from "./pagination";
import Url from "domurl";

export default {
  props: [
      'statusPaid',
      'statusWaiting'
  ],
  data: function(){
    return {
      filter: "all"
    }
  },
  components: {
    Transactions,
    Pagination,
    UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
  },
  methods: {
    applyFilter: function(){

      let url = new Url(window.location.url)

      // remove old params
      delete url.query.status;
      delete url.query.order;
      delete url.query.tr_type;
      delete url.query.p;

      // switch case on the current selected filter
      switch (this.filter) {
        case "all":
          break;
        case "with_invoice":
          url.query.tr_type = this.filter;
          break;
        default:
          // "status" case
          url.query.status=this.filter;
          break;
      }
      window.location = url;
    }
  },
  mounted() {
    let url = new Url(window.location.url);
    if (url.query.status && [this.statusPaid, this.statusWaiting].includes(url.query.status)) {
      this.filter = url.query.status;
    }
    if (url.query.tr_type &&  ["with_invoice"].includes(url.query.tr_type)) {
      this.filter = url.query.tr_type;
    }
  }
}
</script>
